var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" TEST "+_vm._s(_vm.url)+" "),_c('iframe',{staticClass:"if",attrs:{"src":_vm.url,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }